import Vue from 'vue'
import VueRouter from "vue-router";

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new VueRouter({
    mode: 'history',
    //切换页面回到顶部
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    },
    routes: [
        {
            path: "/",
            redirect: "/index"
        },
        {
            path: '/Home',
            component: () =>
                import ('../view'),
            children: [
                {
                    path: '/index',
                    component: () =>
                        import ("../view/Home.vue"),
                    meta: {title: "首页", keepAlive: false}
                },
                {
                    name: 'search',
                    path: '/search',
                    component: () =>
                        import ("../view/search.vue"),
                    meta: {title: "搜索", keepAlive: false}
                },
                {
                    path: '/about',
                    component: () =>
                        import ("../view/About.vue"),
                    meta: {title: "关于我们", keepAlive: false}
                },
                {
                    path: '/announcement',
                    component: () =>
                        import ("../view/announcement.vue"),
                    meta: {title: "公告", keepAlive: false}
                },
                // {
                //     path: '/memberFc1',
                //     component: () =>
                //         import ("../view/memberFc.vue"),
                //     meta: {title: "会长风采", keepAlive: false}
                // },
                // {
                //     path: '/memberDetail',
                //     component: () =>
                //         import ("../view/memberDetail.vue"),
                //     meta: {title: "会员详情", keepAlive: false}
                // },
                {
                    path: '/detail',
                    component: () =>
                        import ("../view/detail.vue"),
                    meta: {title: "详情", keepAlive: false}
                },
                // {
                //     path: '/memberFcDetail',
                //     component: () =>
                //         import ("../view/memberFcDetail.vue"),
                //     meta: {title: "会长风采详情", keepAlive: false}
                // },
                // {
                //     path: '/information',
                //     component: () =>
                //         import ("../view/information.vue"),
                //     meta: {title: "资讯", keepAlive: false}
                // },
                // {
                //     path: '/informationDetail',
                //     component: () =>
                //         import ("../view/informationDetail.vue"),
                //     meta: {title: "资讯详情", keepAlive: false}
                // },
                {
                    path: '/courseList',
                    component: () =>
                        import ("../view/courseList.vue"),
                    meta: {title: "课程展示", keepAlive: false}
                },
                {
                    path: '/policyNews',
                    component: () =>
                        import ("../view/policyNews.vue"),
                    meta: {title: "政策新闻", keepAlive: false}
                },
                {
                    path: '/examList',
                    component: () =>
                        import ("../view/examList.vue"),
                    meta: {title: "在线考试", keepAlive: false}
                },
				{
				    path: '/feature',
				    component: () =>
				        import ("../view/feature.vue"),
				    meta: {title: "特色专区", keepAlive: false}
				},
                {
                    path: '/publicCourses',
                    component: () =>
                        import ("../view/publicCourses.vue"),
                    meta: {title: "公开课程", keepAlive: false}
                },
                {
                    path: '/information',
                    component: () =>
                        import ("../view/information.vue"),
                    meta: {title: "个人信息", keepAlive: false}
                },
                {
                    path: '/kaoshi',
                    component: () =>
                        import ("../view/kaoshi.vue"),
                    meta: {title: "开始考试", keepAlive: false}
                },
                {
                    path: '/myCourseList',
                    component: () =>
                        import ("../view/myCourseList.vue"),
                    meta: {title: "我的课程", keepAlive: false}
                },
                {
                    path: '/courseDetail',
                    component: () =>
                        import ("../view/courseDetail.vue"),
                    meta: {title: "课程详情", keepAlive: false}
                },
            ]
        },
        {
            path: '/login',
            component: () =>
                import ("../view/login.vue"),
            meta: {title: "登录", keepAlive: false}
        },
		{
		    path: '/support',
		    component: () =>
		        import ("../view/support.vue"),
		    meta: {title: "技术支持", keepAlive: false}
		},
		{
		    path: '/performance',
		    component: () =>
		        import ("../view/performance.vue"),
		    meta: {title: "成绩查询", keepAlive: false}
		},
        {
            path: '/mycourseDetail',
            component: () =>
                import ("../view/mycourseDetail.vue"),
            meta: {title: "课程大纲", keepAlive: false}
        },
        {
            path: '/chengji',
            component: () =>
                import ("../view/chengji.vue"),
            meta: {title: "考试成绩", keepAlive: false}
        },
        {
            path: '/proof',
            component: () =>
                import ("../view/proof.vue"),
            meta: {title: "学时证明", keepAlive: false}
        },
    ]
})
